import { useEffect, useRef } from "react";
import { X } from "lucide-react";
import IconButton from "./IconButton";

export default function Modal({ open, onClose, title, description, children, className = "max-w-2xl" }) {
  const closeRef = useRef(null);
  // Quem usa o Modal costuma passar uma função nova a cada render. Se ela fosse dependência do
  // efeito, o foco voltaria ao botão X a cada letra digitada em um campo do modal.
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => { if (event.key === "Escape") onCloseRef.current?.(); };
    window.addEventListener("keydown", onKeyDown);
    closeRef.current?.focus();
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open]);
  if (!open) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/40 p-4" role="presentation">
    <section className={`max-h-[calc(100vh-2rem)] w-full overflow-y-auto rounded-xl bg-white shadow-xl ${className}`} role="dialog" aria-modal="true" aria-labelledby="modal-title">
      <header className="flex items-start justify-between gap-4 border-b border-gray-200 px-5 py-4">
        <div><h2 id="modal-title" className="text-lg font-semibold text-gray-900">{title}</h2>{description && <p className="mt-1 text-sm text-gray-500">{description}</p>}</div>
        <IconButton ref={closeRef} icon={X} label="Fechar" variant="ghost" onClick={onClose} />
      </header>
      <div className="p-5">{children}</div>
    </section>
  </div>;
}
